import { createAsyncThunk } from '@reduxjs/toolkit'
import * as api from './api'
import { COMPANY, ADD_COMPANY, UPDATE_COMPANY, DELETE_COMPANY } from './types'

export const fetchCompany = createAsyncThunk(COMPANY, api.fetchCompany)
export const addCompany = createAsyncThunk(ADD_COMPANY, api.addCompany)
export const updateCompany = createAsyncThunk(UPDATE_COMPANY, api.updateCompany)
export const deleteCompany = createAsyncThunk(DELETE_COMPANY, api.deleteCompany)
